/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable camelcase */
// @ts-nocheck
import { createAsyncAction } from 'Helpers/redux'
import { APP } from 'Configs/App'
import { debounce } from 'lodash'
import { StripePayment } from 'Types/index'

import { apiCall } from './api'

export const CHANGE_CAMPAIGN = createAsyncAction('CHANGE_CAMPAIGN')
export const changeCampaign = (
  { campaign_id, genres_ids, languages_ids, moods_ids, max_price },
  callback?: (err, res) => void
) =>
  apiCall({
    // OLD v1 method: 'patch',
    method: 'put',
    endpoint: '/campaign/update-campaign',
    query: {
      campaign_id,
      genres_ids,
      languages_ids,
      moods_ids,
      max_price,
    },
    types: CHANGE_CAMPAIGN,
    callback,
  })

export const SUBMIT_BLUESNAP_PAYMENT_USING_SHOPPER_ID = createAsyncAction(
  'SUBMIT_BLUESNAP_PAYMENT_USING_SHOPPER_ID'
)

export const submitBluesnapPaymentUsingShopperId = (
  amount,
  campaign_id,
  cardLastFourDigits,
  cardType,
  country,
  current_balance,
  balance_used,
  threeDSecure,
  campaign_value,
  cardData,
  callback
) =>
  apiCall({
    method: 'post',
    endpoint: '/bluesnap/payment/vaulted-shopper',
    query: {
      amount,
      campaign_id,
      cardLastFourDigits,
      cardType,
      country,
      current_balance,
      balance_used,
      threeDSecure,
      campaign_value,
      cardData,
    },
    types: SUBMIT_BLUESNAP_PAYMENT_USING_SHOPPER_ID,
    callback,
  })

export const CHANGE_CAMPAIGN_GENRE = createAsyncAction('CHANGE_CAMPAIGN_GENRE')
export const changeCampaignGenres = (trackID, genres, callback) =>
  apiCall({
    method: 'put',
    endpoint: '/campaign/update-track-genres',
    query: {
      track_id: trackID,
      genre_ids: genres,
    },
    types: CHANGE_CAMPAIGN_GENRE,
    callback,
  })

export const UPDATE_CAMPAIGN = createAsyncAction('UPDATE_CAMPAIGN')
export const updateCampaign = (
  {
    campaign_id,
    genre_ids,
    languages_ids,
    mood_ids,
    max_price,
    max_followers,
    is_max_price,
    is_min_price,
  }: {
    campaign_id: string
    genre_ids: Array<number>
    languages_ids: Array<number>
    mood_ids?: Array<number>
    max_price: number
    max_followers?: number
    is_min_price: boolean
    is_max_price: boolean
  },
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  callback?: any
) =>
  apiCall({
    method: 'patch',
    endpoint: '/campaign/update-campaign',
    query: {
      campaign_id,
      genre_ids,
      languages_ids,
      mood_ids,
      max_price,
      max_followers,
      is_max_price,
      is_min_price,
    },
    types: UPDATE_CAMPAIGN,
    callback,
  })

export const GET_CURATORS_LIST = createAsyncAction('GET_CURATORS_LIST')
export const getCuratorsList = (id, callback) =>
  apiCall({
    method: 'get',
    endpoint: `/campaign/schedule/${id}`,
    types: GET_CURATORS_LIST,
    callback,
  })

export const UPDATE_SCHEDULED_CAMPAIGN = createAsyncAction(
  'UPDATE_SCHEDULED_CAMPAIGN'
)
export function updateScheduledCampaign(campaign) {
  return {
    type: UPDATE_SCHEDULED_CAMPAIGN.SUCCESS,
    payload: campaign,
  }
}

export const SET_CHECKOUT_STEP = 'SET_CHECKOUT_STEP'
export const setCheckoutStep = payload => ({
  type: SET_CHECKOUT_STEP,
  payload,
})

export const CHECK_COUPON = createAsyncAction('CHECK_COUPON')
export const checkCoupon = (
  value,
  callback: (
    error: { error: string },
    res: { coupon: { discount: number; value: string } }
  ) => void
) =>
  apiCall({
    method: 'get',
    endpoint: `/user/coupon/${value}`,
    types: CHECK_COUPON,
    callback,
  })

export const REMOVE_COUPON = 'REMOVE_COUPON'
export const removeCoupon = () => ({
  type: REMOVE_COUPON,
})

// export const GET_BLUESNAP_PFTOKEN = createAsyncAction('GET_BLUESNAP_PFTOKEN')
// export const getBluesnapPftoken = () =>
//   apiCall({
//     method: 'get',
//     endpoint: '/bluesnap/pfToken',
//     types: GET_BLUESNAP_PFTOKEN,
//   })

export const GET_BLUESNAP_PFTOKEN = createAsyncAction('GET_BLUESNAP_PFTOKEN')
export const getBluesnapPftoken = (
  callback?: (err: string, payload: { pfToken: string }) => void
) =>
  apiCall({
    method: 'post',
    endpoint: `${APP.TIKTOK_SERVER}/payment/bluesnap/pf-token`,
    types: GET_BLUESNAP_PFTOKEN,
    callback,
  })

export const GET_VAULTED_SHOPPER = createAsyncAction('GET_VAULTED_SHOPPER')
export const getVaultedShopper = () =>
  apiCall({
    method: 'get',
    endpoint: `${APP.TIKTOK_SERVER}/payment/bluesnap/shopper`,
    types: GET_VAULTED_SHOPPER,
  })

export const GET_BLUESNAP_PAYMENT = createAsyncAction('GET_BLUESNAP_PAYMENT')
export const getBluesnapPayment = (campaign_id, amount, callback) =>
  apiCall({
    method: 'get',
    endpoint: `/bluesnap/payment?campaign_id=${campaign_id}&amount=${amount}`,
    types: GET_BLUESNAP_PAYMENT,
    callback,
  })

export const SUBMIT_BLUESNAP_PAYMENT = createAsyncAction(
  'SUBMIT_BLUESNAP_PAYMENT'
)

export const SUBMIT_STRIPE_PAYMENT = createAsyncAction('GET_BLUESNAP_PAYMENT')
export const submitStripePayment = (
  payment: StripePayment,
  callback: (err: string, res: { link: string }) => void
) =>
  apiCall({
    method: 'post',
    query: payment,
    endpoint: `${APP.TIKTOK_SERVER}/payment/stripe/pay`,
    types: SUBMIT_STRIPE_PAYMENT,
    callback,
  })

export const submitBluesnapPayment = ({
  amount,
  campaigns,
  country,
  couponId,
  pfToken,
  firstName,
  lastName,
  cardLastFourDigits,
  cardType,
  isNewCard,
  threeDSecure,
  callback,
}: {
  amount: number
  campaigns: Array<{
    type: 'spotify' | 'tiktok'
    genres: Array<number>
    languages: Array<number>
    amount: number
    startDate: Date
    isDanceRequested: boolean
    comment: string
    campaignId: number
  }>
  country: string
  couponId: number
  pfToken: string
  firstName: string
  lastName: string
  cardLastFourDigits: string
  cardType: string
  isNewCard: boolean
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  threeDSecure?: any
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  callback: (err: any, res: any) => void
}) =>
  apiCall({
    method: 'post',
    endpoint: `${APP.TIKTOK_SERVER}/payment/bluesnap/charge`,
    query: {
      amount,
      campaigns,
      country,
      couponId,
      pfToken,
      firstName,
      lastName,
      cardLastFourDigits,
      cardType,
      isNewCard,
      threeDSecure,
    },
    types: SUBMIT_BLUESNAP_PAYMENT,
    callback,
  })

export const GET_AUDIENCE_TIKTOK = createAsyncAction('GET_AUDIENCE_TIKTOK')
export const getAudienceTiktok = (
  amount: number,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  callback?: (e: any) => void
) =>
  apiCall({
    method: 'get',
    endpoint: `${APP.TIKTOK_SERVER}/artist/tiktok/expected-reach/?amount=${amount}`,
    types: GET_AUDIENCE_TIKTOK,
    callback,
  })

export const SET_CURATORS_LIST_IS_EMPTY = 'SET_CURATORS_LIST_IS_EMPTY'
export const setCuratorsListIsEmpty = payload => ({
  type: SET_CURATORS_LIST_IS_EMPTY,
  payload,
})

export const GET_CAMPAIGN_BUDGET_RANGE = createAsyncAction(
  'GET_CAMPAIGN_BUDGET_RANGE'
)
export const getCampaignBudgetRange = (
  campaignId: string,
  callback: (e: unknown) => void
) =>
  apiCall({
    method: 'get',
    endpoint: `/campaign/budget-range/${campaignId}`,
    types: GET_CAMPAIGN_BUDGET_RANGE,
    callback,
  })

export function updateCampaignThunkInner(campaign, makeUpdate) {
  return (dispatch, getState) => {
    dispatch(updateScheduledCampaign(campaign))
    if (makeUpdate) {
      dispatch(updateScheduledCampaign({ ...campaign, loading: true }))

      const {
        schedule: { scheduledCampaign },
      } = getState()

      const languageIds = scheduledCampaign.languages.map(
        language => language.id
      )

      const updatedCampaign = {
        campaign_id: scheduledCampaign.id,
        genre_ids: scheduledCampaign.genres.map(genre => genre.id),
        languages_ids: languageIds,
        max_price: scheduledCampaign.price,
        // max_followers: Number(selectedMaxAuditory),
        is_max_price: scheduledCampaign.isMaxPrice,
        is_min_price: scheduledCampaign.isMinPrice,
      }

      dispatch(updateCampaign(updatedCampaign))
        .then(({ payload }) => {
          if (payload) {
            dispatch(
              updateScheduledCampaign({
                ...scheduledCampaign,
                audience: {
                  followers: payload.followers,
                  maxCurators: payload.max_curators,
                  maxFollowers: payload.max_followers,
                  maxPlaylists: payload.max_playlists,
                  minPlaylists: payload.min_playlists,
                  playlists: payload.playlists,
                  curators: payload.curators_count,
                },
                price: payload.price,
                loading: false,
                overrun_budget: payload.overrun_budget,
              })
            )
          }
        })
        .catch()
    }
  }
}

const innerFunction = debounce(
  (dispatch, ...args) =>
    // @ts-ignore
    setTimeout(() => dispatch(updateCampaignThunkInner(...args)), 1500),
  1500
)
export const updateCampaignThunk = (...args) => dispatch =>
  innerFunction(dispatch, ...args)
